"use strict";

var _ = require("underscore");
var Reflux = require("reflux");
var UserSelectFilterActions = require("../actions/user-select-filter-actions.js");

var UserSelectFilterStore = Reflux.createStore({
  state: {
    users: []
  },
  setState: function(state){
    this.state = _.defaults(state, this.state);
    this.trigger(this.state);
    return this.state;
  },
  getInitialState: function() {
    return {
      users: []
    };
  },
  init: function(){
    this.listenTo(UserSelectFilterActions.loadUsers.completed, this.onLoadUsersCompleted);
    this.listenTo(UserSelectFilterActions.populate, this.onPopulate);
    this.state = this.getInitialState();
  },
  onPopulate: function(userSelectFilter){
    this.setState(userSelectFilter);
  },
  onLoadUsersCompleted: function(users){
    _.each(users, function(user, i){
      if (user.id == window.loggedUserId) {
        users.splice(i, 1);
        users.unshift(user);
      }
    });
    this.state.users = users;
    this.trigger(this.state);
  },
});

module.exports = UserSelectFilterStore;



// WEBPACK FOOTER //
// ./app/screens/Activity/stores/user-select-filter-store.js